export enum TagTypes {
  DATE = 'date',
  PLAYER = 'player',
  TEAM = 'team',
  TEMPLATE = 'template',
  SPORT = 'sport',
  COACH = 'coach',
  VENUE = 'venue',
  NO_TAG = 'no tag'
}
